<template>
  <div>
    <div>
      <b-form-group
        :label="$t('tracking.cargo.disapprovedReason')"
        label-for="DisapprovedReasonId"
      >
        <b-form-select
          :options="disapprovedOptions"
          v-model="model.disapprovedReasonId"
        >
        </b-form-select>
        <span class="text-danger" v-if="modelstate['DisapprovedReasonId']">
          {{ modelstate["DisapprovedReasonId"][0] }}
        </span>
      </b-form-group>
      <b-form-group
        :label="$t('tracking.cargo.disapprovedDescription')"
        label-for="DisapprovedDescription"
      >
        <b-form-textarea
          id="DisapprovedDescription"
          type="text"
          placeholder="Motivo da reprovação"
          v-model="model.disapprovedDescription"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['DisapprovedDescription']">
          {{ modelstate["DisapprovedDescription"][0] }}
        </span>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";
export default {
  components: {
    FullscreenSidebar,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data() {
    return {
      disapprovedOptions: [],
      values: [],
    };
  },
  created() {
    this.getDisapprovedoptions();
    this.newModel();
  },
  methods: {
    getDisapprovedoptions() {
      this.$api
        .get("v1/disapprovedReason/dropdownOptions")
        .then((response) => {
          this.disapprovedOptions = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    newModel() {
      if (this.model.disapprovedReasonId > 0)
        this.model.disapprovedReasonId = 0;
      if (this.model.disapprovedDescription != "")
        this.model.disapprovedDescription = "";
      this.$forceUpdate();
    },
  },
};
</script>
